// TODO: copy may change (especially the headline)
// error behavior for GraphQL errors and missing email may also change
// pending input from product
import React from 'react';
import { Redirect } from 'react-router-dom';

import { useQuery } from '@apollo/client';
import { Box, Divider, Flex, Loader, Text } from '@opendoor/bricks/core';
import Layout from '@opendoor/bricks/deprecated/UNSAFE_layout/Layout';
import { Illustration } from '@opendoor/cinderblocks/platform/Illustration';
import { Sentry } from '@opendoor/observability';

import { GET_LEAD, IGetLead } from '../../src/graphql/queries/GetLead';
import { ERROR_PAGE_ROUTE } from '../../src/routes/routes';

type WelcomeLeadPageProps = {
  match: {
    params: {
      sellerInputId: string;
    };
  };
};

const WelcomeLeadPage: React.FC<WelcomeLeadPageProps> = ({ match }) => {
  const idFromSlug = match.params.sellerInputId;

  const { loading, error, data } = useQuery<IGetLead>(GET_LEAD, {
    variables: { sellerInputId: idFromSlug },
    fetchPolicy: 'network-only',
  });

  if (loading) {
    return <Loader />;
  }

  if (error) {
    Sentry.withScope((scope) => {
      scope.setExtra('seller_input_uuid', idFromSlug);
      scope.setExtra('error', JSON.stringify(error));
      Sentry.captureException(error);
    });
    return <Redirect to={ERROR_PAGE_ROUTE} />;
  }

  const email = data?.lead?.initialCustomer?.email;

  if (!email) {
    Sentry.withScope((scope) => {
      scope.setExtra('seller_input_uuid', idFromSlug);
      Sentry.captureMessage('WelcomeLeadPage: Email not found');
    });
    return <Redirect to={ERROR_PAGE_ROUTE} />;
  }

  return (
    <div style={{ backgroundColor: 'FF0000' }}>
      <Layout headerType="HIDE_NAV" footerType="NONE">
        <Box>
          <Divider />
        </Box>
        <Box
          mt={[11, 8]}
          marginX="auto"
          maxWidth="600px"
          textAlign="center"
          display="flex"
          flexDirection="column"
          mx={[7, 'auto']}
        >
          <Text size="s4" fontWeight="bold" mb={3}>
            Click the link in your email inbox to view your Opendoor cash offer
          </Text>
          <Text size="s1" my={7}>
            We sent the email to <a href={`mailto:${email}`}>{email}</a>
          </Text>
          <Box mt={7} mx={10}>
            <Divider />
          </Box>

          <Text size="s3" fontWeight="bold" my={8}>
            What happens next
          </Text>

          <Flex flexDirection="row" alignItems="center" mb={8} mx="auto">
            <Illustration
              type="spot"
              illustrationName="Envelope-Contract"
              width="60px"
              height="60px"
              mr={8}
            />
            <Text size="s1" maxWidth="330px" textAlign="left">
              Click the link in your email inbox to learn more about your cash offer
            </Text>
          </Flex>

          <Flex flexDirection="row" alignItems="center" mx="auto">
            <Illustration
              type="spot"
              illustrationName="Video Walkthrough"
              width="60px"
              height="60px"
              mr={8}
            />
            <Text size="s1" maxWidth="330px" textAlign="left">
              Schedule a virtual assessment for your home
            </Text>
          </Flex>
          <Box mt={7} mx={10}>
            <Divider />
          </Box>
          <Text size="s1" my={7}>
            If you have any questions, contact our support team at{' '}
            <a href="mailto:support@opendoor.com">support@opendoor.com</a>
          </Text>
        </Box>
      </Layout>
    </div>
  );
};

export default WelcomeLeadPage;
